export default {
    getAllShiftType: [],
    getAllSegmentType: [],
    getAllScheduleType: [],
    getAllLeaveTypes:[], 
    claimsCategory: [],
    claimsSubCategory: [],
    getAllLoanType:[],
    getAllLoanName: [],
    loanCategory: [],
    loanSubCategory: [],
    // termsType:[{ label:'Daily', value: 1 },
    //     { label: 'Weekly', value: 2 },
    //     { label: 'BiMonthly', value: 3 },
    //     { label: 'Monthly', value: 4 },
    //     { label: 'Quarterly', value: 5 },
    //     { label: 'Yearly', value: 6 }],
    overtimeTypes: [],
    
    getAllCountryLookup: [],
    getAllDepartment: [],
    getAllBranch: [],
    getAllPosition: [],
    getAllDivision: [],
    getAllSection: [],
    getAllEmployeeCategory: [],
    getAllEarningsType: [],
    getAllEarningsCategory: [],
    getAllDeductionsType: [],
    getAllDeductionsCategory: [],
    getAllCivilStatus: [],
    getAllCreatePayrollTypeLookup: [],
    getAllNationality: [],
    getAllReligion: [],
    getAllRelationshipLookup: [],
    getAllAccreditationType: [],
    getAllRankLookup: [],
    getAllAssociationLookup: [],
    getAllBankLookup: [],
    getAllPeriodLookup: [],
    getAllBenefitTypeLookup:[],
    getAllDegreeLookup:[],
    getAllAreaOfStudyLookup:[],
    getAllLineOfBusinessLookup: [],
    getAllInstitutionLookup:[],
    getAllAwardLookup:[],
    getAllMarketSegmentLookup:[],
    getAllAppraisalTypeLookup:[],
    getAllAppraisalRatingLookup:[],
    getAllSalaryBasedOnLookup: [],
    getAllScheduleNumber: [],
    getAllTaxReferenceLookup: [],
    getAllPaymentModeLookup:[],
    getAllViolationLookup: [],
    getAllViolationActionLookup: [],
    getAllMedicalProcedureLookup: [],


    
    gender: [
        { gender: 'Unspecified', value:0 },
        { gender: 'Male', value:1 },
        { gender: 'Female', value:2 },
        { gender: 'Others', value:3 },
    ],
    residentialType:[
        { resType: 'Unspecified', value:0 },
        { resType: 'Apartment', value:1 },
        { resType: 'Subdivision', value:2 },
        { resType: 'Condominium', value:3 },
        { resType: 'Townhouse', value:4 },
        { resType: 'Others', value:5 }
    ],
    employeeStatus:[
        { status: 'All', value: 0 },
        { status: 'Applicant', value: 1 },
        { status: 'Active', value: 2 },
        { status: 'Resigned', value: 3 },
        { status: 'Terminated', value: 4 },
        { status: 'End Of Contract', value: 5 },
        { status: 'OnHold', value: 6 },
        { status: 'OnPool', value: 7 }
    ],
    employmentStatus: [
        { employStatus: 'Unspecified', value: 0 },
        { employStatus: 'Probationary', value: 1 },
        { employStatus: 'Contractual', value: 2 },
        { employStatus: 'Regular', value: 3 },
        { employStatus: 'Project', value: 4 }
    ],
    accountType: [
        
        { accountType: 'Unspecified', value:0 },
        { accountType: 'Savings', value:1 },
        { accountType: 'Current', value:2 },
        { accountType: 'Dollar', value:3 },
    ],
    monthName: [
        { monthName: 'January', value: 1 }, 
        { monthName: 'February', value: 2 }, 
        { monthName: 'March', value: 3 }, 
        { monthName: 'April', value: 4 }, 
        { monthName: 'May', value: 5 }, 
        { monthName: 'June', value: 6 }, 
        { monthName: 'July', value: 7 },
        { monthName: 'August', value: 8 }, 
        { monthName: 'September', value: 9 }, 
        { monthName: 'October', value: 10 }, 
        { monthName: 'November', value: 11 }, 
        { monthName: 'December', value: 12 }
    ],
    daysName: [
        { dayName: 'Sunday', value: 1 },
        { dayName: 'Monday', value: 2 },
        { dayName: 'Tuesday', value: 3 },
        { dayName: 'Wednesday', value: 4 },
        { dayName: 'Thursday', value: 5 },
        { dayName: 'Friday', value: 6 },
        { dayName: 'Saturday', value: 7 }
    ],
    templateName: [
        "Log Hours",
        "Overtime",
        "Earnings",
        "Deductions",
        "Loans"
    ],
    getAllLoanStatus:[
        { status: 'Active', value: 1 },
        { status: 'Completed', value: 2}
    ],
    getAllTermsType: [
        { termsTypeName: "Daily", value:  1 },
        { termsTypeName: "Weekly", value:  2 },
        { termsTypeName: "BiMonthly", value:  3 },
        { termsTypeName: "Monthly", value:  4 },
        { termsTypeName: "Quarterly", value:  5},
        { termsTypeName: "Yearly", value:  6 }
    ],
    moduleLookup: [
        { moduleName: "Timekeeping", value: 1 },
        { moduleName: "LeaveManagement", value: 2 },
        { moduleName: "Overtime", value: 3 },
        { moduleName: "Loans", value: 4 },
        { moduleName: "Claims", value: 5 },
        { moduleName: "HRIS", value: 6 },
        { moduleName: "Payroll", value: 7 }
    ],
    priorityLookup: [
        { priorityName: "First", value: 1 },
        { priorityName: "Second", value: 2 },
        { priorityName: "Third", value: 3 },
    ],
    addToLookup: [
        { label: "None", value: 0 },
        { label: "BasicPay", value: 1 },
        { label: "GrossPay", value: 2 },
        { label: "SSS", value: 3 },
        { label: "Philhealth", value: 4 },
        { label: "Pagibig", value: 5 },
        { label: "WHTax", value: 6},
        { label: "Earnings", value: 7},
        { label: "Deductions", value: 8}
    ]
    
}